import React, { useState } from 'react';
import { BookOpen, Headphones, NotebookPen, Lock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function PremiumBonusSection() {
  const [openBenefits, setOpenBenefits] = useState<{
    [key: number]: boolean;
  }>({});
  const toggleBenefits = (bonusNumber: number) => {
    setOpenBenefits(prev => ({
      ...prev,
      [bonusNumber]: !prev[bonusNumber]
    }));
  };
  const scrollToSecretSection = () => {
    const secretSection = document.getElementById('zona-exclusiva');
    if (secretSection) {
      secretSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const bonuses = [{
    icon: BookOpen,
    number: 1,
    title: 'Manual de Decisiones Claras con Tarot',
    subtitle: 'Cómo acceder a respuestas tan obvias sobre amor, dinero y bienestar que ignorarlas sería sabotear tu propia vida',
    value: '$28.99',
    description: 'El ebook completo donde aprendes a usar el tarot como una herramienta lógica para pensar mejor, no como algo mágico para adivinar tu destino.',
    note: 'Este bono elimina la percepción de suerte y convierte al tarot en un recurso mental estructurado para decidir mejor.'
  }, {
    icon: Headphones,
    number: 2,
    title: 'Audiolibro Oficial',
    subtitle: '',
    value: '$21.97',
    description: 'Escucha el contenido completo sin tener que sentarte a leer. Consúmelo mientras manejas, trabajas o entrenas. Convierte tiempos muertos en progreso real.',
    benefits: ['No necesitas "encontrar tiempo"', 'Aprendes sin esfuerzo adicional', 'Interiorizas el contenido por repetición', 'Avanzas sin fricción']
  }, {
    icon: NotebookPen,
    number: 3,
    title: 'El Cuaderno de Preguntas que Cambian tu Vida',
    subtitle: '',
    value: '$17.99',
    description: 'Este workbook te obliga a dejar de autoengañarte y llegar a una decisión real. Son preguntas diseñadas para exponerte tu verdad, no para hacerte sentir bien.',
    benefits: ['Identificas exactamente qué quieres', 'Descubres qué te detiene y por qué', 'Tomas decisiones sin ansiedad', 'Dejas de repetir patrones emocionales']
  }, {
    icon: Lock,
    number: 4,
    title: 'Zona Exclusiva para Compradores',
    subtitle: '',
    value: '$47.87',
    description: 'Acceso privado solo para clientes. Aquí tienes contenido adicional, recursos exclusivos y 2 regalos de bienvenida que no existen públicamente.',
    benefits: ['Ventaja injusta frente a quienes no compran', 'Material extra que acelera tus resultados', 'Sensación de pertenecer a una comunidad "que sí hace"', 'Incentivos que no obtendrás en ningún otro lado'],
    hasButton: true
  }];
  return <section id="bonos" className="py-20 px-4 bg-[#0C0A09] border-t border-[#3b3330]" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-133">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5EDE0] mb-6" data-id="element-134">
            Bonos Premium Incluidos
          </h2>

          <div className="inline-block" data-id="element-135">
            <div className="flex items-center gap-4 mb-2" data-id="element-136">
              <span className="text-2xl text-[#F5EDE0]/50 line-through" data-id="element-137">
                Valor Total: $116.89
              </span>
            </div>
            <div className="text-5xl font-bold text-[#CFA86A] px-8 py-4 rounded-lg" style={{
            textShadow: '0 0 30px rgba(207, 168, 106, 0.5)'
          }} data-id="element-138">
              HOY SOLO $28.99
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-139">
          {bonuses.map(bonus => {
          const Icon = bonus.icon;
          const isOpen = openBenefits[bonus.number] || false;
          return <div key={bonus.number} className="relative p-8 rounded-lg border border-[#CFA86A]/20 bg-[#0C0A09]" style={{
            boxShadow: '0 0 40px rgba(207, 168, 106, 0.1)'
          }} data-id="element-140">
                {/* Icon & Number */}
                <div className="flex items-start gap-4 mb-4" data-id="element-141">
                  <div className="w-14 h-14 rounded-full flex items-center justify-center border border-[#CFA86A]/30" style={{
                background: 'radial-gradient(circle, rgba(207, 168, 106, 0.15), transparent)'
              }} data-id="element-142">
                    <Icon className="w-7 h-7 text-[#CFA86A]" data-id="element-143" />
                  </div>
                  <div className="flex-1" data-id="element-144">
                    <div className="text-xs text-[#CFA86A] font-semibold tracking-wider mb-1" data-id="element-145">
                      BONO #{bonus.number}
                    </div>
                    <h3 className="text-xl font-bold text-[#F5EDE0] leading-tight" data-id="element-146">
                      {bonus.title}
                    </h3>
                  </div>
                  <div className="text-right" data-id="element-147">
                    <div className="text-sm text-[#F5EDE0]/50 mb-1" data-id="element-148">Valor</div>
                    <div className="text-2xl font-bold text-[#CFA86A]" data-id="element-149">
                      {bonus.value}
                    </div>
                  </div>
                </div>

                {/* Subtitle */}
                {bonus.subtitle && <p className="text-sm text-[#F5EDE0]/80 italic mb-4 leading-relaxed" data-id="element-150">
                    {bonus.subtitle}
                  </p>}

                {/* Description */}
                <p className="text-[#F5EDE0]/70 mb-4 leading-relaxed" data-id="element-151">
                  {bonus.description}
                </p>

                {/* Benefits - Collapsible */}
                {bonus.benefits && <div className="mb-4" data-id="element-152">
                    <button onClick={() => toggleBenefits(bonus.number)} className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg border border-[#CFA86A]/30 bg-[#0C0A09]/50 hover:bg-[#CFA86A]/10 hover:border-[#CFA86A]/50 transition-all duration-300 cursor-pointer group" style={{
                boxShadow: isOpen ? '0 0 20px rgba(207, 168, 106, 0.2)' : '0 0 10px rgba(207, 168, 106, 0.1)'
              }} data-id="element-153">
                      <div className="flex items-center gap-3" data-id="element-154">
                        {/* Treasure Chest Icon */}
                        <motion.div animate={{
                    rotateX: isOpen ? 45 : 0
                  }} transition={{
                    duration: 0.4,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="relative" data-id="element-155">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#CFA86A]" data-id="element-156">
                            <rect x="3" y="10" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-157" />
                            <path d="M3 14h18" stroke="currentColor" strokeWidth="2" data-id="element-158" />
                            <rect x="6" y="6" width="12" height="4" rx="1" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-159" />
                            <circle cx="12" cy="14" r="1.5" fill="currentColor" data-id="element-160" />
                          </svg>

                          {/* Golden glow when open */}
                          <AnimatePresence data-id="element-161">
                            {isOpen && <motion.div initial={{
                        opacity: 0,
                        scale: 0.8
                      }} animate={{
                        opacity: 1,
                        scale: 1
                      }} exit={{
                        opacity: 0,
                        scale: 0.8
                      }} transition={{
                        duration: 0.3
                      }} className="absolute inset-0 -z-10" style={{
                        filter: 'blur(8px)',
                        background: 'radial-gradient(circle, rgba(207, 168, 106, 0.6), transparent 70%)'
                      }} data-id="element-162" />}
                          </AnimatePresence>
                        </motion.div>

                        <span className="text-sm font-semibold text-[#CFA86A] group-hover:brightness-110 transition-all" data-id="element-163">
                          Beneficios inmediatos
                        </span>
                      </div>

                      {/* Chevron indicator */}
                      <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-164">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#CFA86A]" data-id="element-165">
                          <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-166" />
                        </svg>
                      </motion.div>
                    </button>

                    <AnimatePresence data-id="element-167">
                      {isOpen && <motion.ul initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.4,
                  ease: [0.22, 1, 0.36, 1]
                }} className="space-y-2 overflow-hidden mt-3 pl-4" data-id="element-168">
                          {bonus.benefits.map((benefit, idx) => <motion.li key={idx} initial={{
                    opacity: 0,
                    x: -10
                  }} animate={{
                    opacity: 1,
                    x: 0
                  }} transition={{
                    duration: 0.3,
                    delay: idx * 0.05
                  }} className="flex items-start gap-2 text-sm text-[#F5EDE0]/80" data-id="element-169">
                              <span className="text-[#CFA86A] mt-1" data-id="element-170">✓</span>
                              <span data-id="element-171">{benefit}</span>
                            </motion.li>)}
                        </motion.ul>}
                    </AnimatePresence>
                  </div>}

                {/* Button for Bonus #4 */}
                {bonus.hasButton && <button onClick={scrollToSecretSection} className="w-full mt-4 px-6 py-3 rounded-lg bg-[#CFA86A] text-[#0C0A09] font-bold tracking-wide transition-all duration-300 hover:brightness-110 flex items-center justify-center gap-2" style={{
              boxShadow: '0 0 20px rgba(207, 168, 106, 0.3)'
            }} data-id="element-172">
                    <Lock className="w-4 h-4" data-id="element-173" />
                    VER ZONA EXCLUSIVA
                  </button>}

                {/* Note */}
                {bonus.note && <p className="text-sm text-[#F5EDE0]/60 italic mt-4 pt-4 border-t border-[#CFA86A]/10" data-id="element-174">
                    {bonus.note}
                  </p>}
              </div>;
        })}
        </div>

        {/* What You're NOT Buying */}
        <div className="max-w-3xl mx-auto mb-12 p-8 rounded-lg border border-red-500/20 bg-[#0C0A09]" data-id="element-175">
          <h3 className="text-2xl font-bold text-[#F5EDE0] mb-6 text-center" data-id="element-176">
            ❌ Si no compras esto, la alternativa es clara:
          </h3>
          <ul className="space-y-3 text-[#F5EDE0]/70" data-id="element-177">
            <li className="flex items-start gap-3" data-id="element-178">
              <span className="text-red-400 mt-1" data-id="element-179">•</span>
              <span data-id="element-180">seguir dudando durante semanas, meses o años</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-181">
              <span className="text-red-400 mt-1" data-id="element-182">•</span>
              <span data-id="element-183">seguir esperando señales que no llegan</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-184">
              <span className="text-red-400 mt-1" data-id="element-185">•</span>
              <span data-id="element-186">seguir pidiendo consejos que no aplicas</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-187">
              <span className="text-red-400 mt-1" data-id="element-188">•</span>
              <span data-id="element-189">seguir viviendo en pausa</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-190">
              <span className="text-red-400 mt-1" data-id="element-191">•</span>
              <span data-id="element-192">seguir posponiendo lo inevitable</span>
            </li>
          </ul>
          <p className="text-center text-[#F5EDE0] font-semibold mt-6 text-lg" data-id="element-193">
            Este producto elimina eso.
          </p>
        </div>

        {/* What Customer Buys */}
        <div className="max-w-2xl mx-auto mb-12 text-center" data-id="element-194">
          <h3 className="text-2xl font-bold text-[#CFA86A] mb-6" data-id="element-195">
            🟢 LO QUE COMPRA EL CLIENTE
          </h3>
          <div className="space-y-3 text-[#F5EDE0]/70 mb-6" data-id="element-196">
            <p data-id="element-197">🚫 No compras un libro</p>
            <p data-id="element-198">🚫 No compras tarot</p>
            <p data-id="element-199">🚫 No compras información</p>
          </div>
          <p className="text-2xl font-bold text-[#F5EDE0] leading-relaxed" data-id="element-200">
            Compras <span className="text-[#CFA86A]" data-id="element-201">certezas</span>. Compras{' '}
            <span className="text-[#CFA86A]" data-id="element-202">avance</span>. Compras tu{' '}
            <span className="text-[#CFA86A]" data-id="element-203">próxima decisión</span>.
          </p>
        </div>

        {/* Final CTA */}
        <div className="max-w-2xl mx-auto text-center" data-id="element-204">
          <h3 className="text-2xl font-bold text-[#F5EDE0] mb-4" data-id="element-205">
            🔥 Haz tu compra ahora y elimina la indecisión de tu vida.
          </h3>
          <p className="text-[#F5EDE0]/70 mb-8 text-lg" data-id="element-206">
            Cada día que dudas, pagas con tiempo lo que aquí puedes resolver con
            acción.
          </p>

          <button onClick={() => {
          // TODO: Add your checkout URL here
          console.log('Navigate to checkout');
        }} className="inline-block px-12 py-5 rounded-lg bg-[#CFA86A] text-[#0C0A09] text-xl font-bold tracking-wide transition-all duration-300 hover:brightness-110" style={{
          boxShadow: '0 0 40px rgba(207, 168, 106, 0.4)'
        }} data-id="element-207">
            Comprar ahora por solo $28.99
          </button>

          <p className="text-sm text-[#F5EDE0]/50 mt-6" data-id="element-208">
            Acceso inmediato a todos los bonos después de la compra
          </p>
        </div>
      </div>
    </section>;
}